var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcExpandSearchSwipe(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "132px",
    height: "132px",
    viewBox: "0 0 132 132",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icExpandSearch") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M170,98 C204.241654,98 232,125.758346 232,160 C232,194.241654 204.241654,222 170,222 C135.758346,222 108,194.241654 108,160 C108,125.758346 135.758346,98 170,98 Z M170,102 C137.967485,102 112,127.967485 112,160 C112,192.032515 137.967485,218 170,218 C202.032515,218 228,192.032515 228,160 C228,127.967485 202.032515,102 170,102 Z M171.279788,128.465902 C181.111115,132.220948 185.878627,143.452503 182.559606,153.056215 C179.281561,162.541363 168.883546,167.365145 160.794309,165.575342 L160.492063,165.50512 L151.625292,187.449735 C151.396095,188.013889 149.994292,189.656502 148.488201,188.781351 C147.042353,187.941206 147.044264,186.598609 147.247605,185.992648 L147.273981,185.92083 L156.140775,163.976182 C146.890298,159.597089 142.65429,148.768498 146.477959,139.274937 C150.420171,129.517161 161.448461,124.710855 171.279788,128.465902 Z M164.34632,185.35 L201.205073,185.35 C202.518353,185.35 203.231069,186.144695 203.231069,187.125 C203.231069,188.065133 202.578812,188.824514 201.387758,188.894704 L201.205073,188.9 L164.34632,188.9 C163.03304,188.9 162.355107,188.105305 162.355107,187.125 C162.355107,186.184867 162.975815,185.425486 164.163864,185.355296 L164.34632,185.35 L201.205073,185.35 Z M173.655301,175.055 L201.424699,175.055 C202.387771,175.055 203.16,175.849695 203.16,176.83 C203.16,177.767783 202.458829,178.525716 201.56702,178.599165 L201.424699,178.605 L173.655301,178.605 C172.692229,178.605 171.92,177.810305 171.92,176.83 C171.92,175.892217 172.621171,175.134284 173.51298,175.060835 L173.655301,175.055 L201.424699,175.055 Z M187.760648,164.76 L201.519352,164.76 C202.429892,164.76 203.16,165.554695 203.16,166.535 C203.16,167.470185 202.500742,168.226515 201.660913,168.303538 L201.519352,168.31 L187.760648,168.31 C186.850108,168.31 186.12,167.515305 186.12,166.535 C186.12,165.599815 186.779258,164.843485 187.619087,164.766462 L187.760648,164.76 L201.519352,164.76 Z M158.126653,131.759556 C154.215736,133.419642 151.128484,136.57104 149.549228,140.515214 C147.124256,146.516851 148.553419,153.388178 153.170299,157.925093 C157.787179,162.462007 164.682554,163.771036 170.64111,161.24178 C176.599665,158.712523 180.447959,152.843077 180.39153,146.370366 C180.335101,139.897655 176.385062,134.096376 170.383326,131.671686 C166.449084,130.067847 162.03757,130.09947 158.126653,131.759556 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-5.6%",
    y: "-4.0%",
    width: "111.3%",
    height: "111.3%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Main",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "New-Members-Grid-OFF-Copy-2",
    transform: "translate(-119.000000, -1566.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "EXPAND-SEARCH-Copy",
    transform: "translate(15.000000, 1470.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icExpandSearch"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcExpandSearchSwipe);
export default __webpack_public_path__ + "static/media/icExpandSearchSwipe.672b62de42e123574efee92f07a4c4cb.svg";
export { ForwardRef as ReactComponent };